<template>
  <div class="animated fadeIn" v-if="!loading">
    <basic-heading title="Receiving Labels" class="print-hidden mb-3" />
    <sample-receiving-labels :samples="samples" :submission="submission" />
  </div>
</template>

<script>
import SampleCollection from "@/collections/lab/SampleCollection";
import SampleReceivingLabels from "@/components/lab/sample/SampleReceivingLabels";
import BasicHeading from "@/components/shared/BasicHeading";
import { getModel } from "@/shared/fetch-utils";

export default {
  name: 'SubmissionReceiveLabelIndex',
  components: {
    BasicHeading,
    SampleReceivingLabels
  },
  data() {
    return {
      submission_id: this.$route.params.submission_id || null,
      submission: null,
      samples: new SampleCollection(),
      loading: true,
    }
  },
  methods: {
    async init() {
      if (this.submission_id) {
        this.submission = await getModel({
          model_type: "submission",
          id: this.submission_id,
          message: this.$bvToast
        });

        this.samples = this.submission.getSamples();
      }

      this.loading = false;
    },
  },
  created() {
    this.loading = true;

    this.init()
  }
};
</script>